export default __webpack_public_path__ + "79e5ed0694a798bb29bd8850fcc47dc3.svg";